export default "__VITE_ASSET__f6d7ea41__"